const getters = {
    getPatologicInfo: state => state.patological
}

export default getters